import I18n from 'I18n';
import { NavMarker } from 'react-rhumb';
import { Set as ImmutableSet } from 'immutable';
// @ts-expect-error Untyped import
import { useSelectedRows } from '../redux/selectedRows';
import { Flex } from 'foundations-components/components/Flex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { ReportsGridCard } from '../components/reportsGrid/ReportsGridCard';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import { BulkActionsContainer } from '../components/reportsGrid/BulkActionsContainer';
import LoadingSkeleton from 'reporting-discover-components/components/shared/LoadingSkeleton';
import { ResultsMessage } from 'foundations-components/transitional/components/ResultsMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
// @ts-expect-error Untyped import
import { hasSufficientReportEditPermission } from 'reporting-action-components/lib/report-logic';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReportsGrid = ({
  error,
  reports,
  isLoading,
  isSearch
}) => {
  const actionableRows = ImmutableSet(reports === null || reports === void 0 ? void 0 : reports.filter(report => hasSufficientReportEditPermission(report)));
  const {
    selectedRows: selectedCards,
    selectRow,
    deselectRow
  } = useSelectedRows({
    actionableRows
  });
  const handleSelectedChange = (report, isSelected) => {
    if (isSelected) {
      selectRow(report);
    } else {
      deselectRow(report);
    }
  };
  if (isLoading) {
    return isSearch ? /*#__PURE__*/_jsxs(CardGrid, {
      marginBlockEnd: "1000",
      paddingBlockEnd: "900",
      columnSize: 500,
      children: [/*#__PURE__*/_jsx(LoadingSkeleton, {
        height: 500
      }), /*#__PURE__*/_jsx(LoadingSkeleton, {
        height: 500
      }), /*#__PURE__*/_jsx(LoadingSkeleton, {
        height: 500
      })]
    }) : /*#__PURE__*/_jsx(LoadingSpinner, {
      layout: "centered",
      grow: true
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "REPORTS_LIST_CONTAINER_FAILURE",
      children: /*#__PURE__*/_jsx(Alert, {
        type: "danger",
        closeable: false,
        titleText: I18n.text('reports.table.failedToLoad.title'),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reports.table.failedToLoad.description"
        })
      })
    });
  }
  if (reports.isEmpty()) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "REPORTS_LIST_CONTAINER",
      children: /*#__PURE__*/_jsx(Flex, {
        justifyContent: "center",
        alignItems: "center",
        marginBlockStart: "800",
        children: /*#__PURE__*/_jsx(ResultsMessage, {
          illustration: "empty-state-charts",
          illustrationProps: {
            width: 187
          },
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reports.table.empty"
          })
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "REPORTS_LIST_CONTAINER",
    children: [/*#__PURE__*/_jsx(BulkActionsContainer, {
      actionableRows: actionableRows
    }), /*#__PURE__*/_jsx(CardGrid, {
      marginBlockEnd: "400",
      columnSize: 500,
      children: reports.map(report => {
        return /*#__PURE__*/_jsx(ReportsGridCard, {
          report: report,
          onSelectReport: handleSelectedChange,
          isSelected: selectedCards.has(report),
          selectedCards: selectedCards
        }, report.get('id'));
      })
    })]
  });
};